/* ==========================================================================
   RACINEA V2 — animaciones de la capa "Sol y crema"
   Nada de aquí toca precios, ofertas ni carrito: solo movimiento.
   Todo se apaga solo si la persona pide menos movimiento en su dispositivo.
   ========================================================================== */
(function () {
  'use strict';

  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conRaton = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Barra de progreso + cabecera que cambia al bajar ---------- */
  function iniciarProgreso() {
    var barra = document.querySelector('.mt-progreso');
    if (!barra && !reducido) {
      barra = document.createElement('div');
      barra.className = 'mt-progreso';
      barra.setAttribute('aria-hidden', 'true');
      document.body.appendChild(barra);
    }
    var pendiente = false;
    function medir() {
      pendiente = false;
      var alto = document.documentElement.scrollHeight - window.innerHeight;
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      if (barra) barra.style.setProperty('--mt-avance', alto > 0 ? Math.min(1, y / alto).toFixed(4) : 0);
      document.documentElement.classList.toggle('mt-defile', y > 24);
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(medir); }
    }, { passive: true });
    window.addEventListener('resize', medir, { passive: true });
    medir();
  }

  /* ---------- Titulares palabra a palabra ---------- */
  function partirEnPalabras(nodo, contador) {
    var hijos = Array.prototype.slice.call(nodo.childNodes);
    hijos.forEach(function (hijo) {
      if (hijo.nodeType === 3) {
        var trozos = hijo.textContent.split(/(\s+)/);
        var frag = document.createDocumentFragment();
        trozos.forEach(function (trozo) {
          if (!trozo) return;
          if (/^\s+$/.test(trozo)) { frag.appendChild(document.createTextNode(' ')); return; }
          var caja = document.createElement('span');
          caja.className = 'mt-mot';
          var dentro = document.createElement('span');
          dentro.textContent = trozo;
          dentro.style.setProperty('--mt-i', contador.n++);
          caja.appendChild(dentro);
          frag.appendChild(caja);
        });
        nodo.replaceChild(frag, hijo);
      } else if (hijo.nodeType === 1 && hijo.tagName !== 'BR' && hijo.tagName !== 'SVG') {
        partirEnPalabras(hijo, contador);
      }
    });
  }

  function iniciarTitulares(raiz) {
    if (reducido || !('IntersectionObserver' in window)) return;
    var titulares = (raiz || document).querySelectorAll('.mt-section h2.mt-h2:not(.mt-mots)');
    if (!titulares.length) return;
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('mt-mots-visible');
        obs.unobserve(e.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });

    titulares.forEach(function (h) {
      // El texto completo sigue ahí para lectores de pantalla y buscadores.
      if (!h.getAttribute('aria-label')) h.setAttribute('aria-label', h.textContent.replace(/\s+/g, ' ').trim());
      partirEnPalabras(h, { n: 0 });
      h.classList.add('mt-mots');
      obs.observe(h);
    });
  }

  /* ---------- Tarjetas que se inclinan hacia el ratón ---------- */
  function iniciarInclinacion(raiz) {
    if (reducido || !conRaton) return;
    var tarjetas = (raiz || document).querySelectorAll('.mt-carte:not([data-mt-tilt])');
    tarjetas.forEach(function (t) {
      // Las tarjetas del carrusel de opiniones no: al deslizar marea.
      if (t.closest('.mt-avis__piste')) return;
      t.setAttribute('data-mt-tilt', '');
      t.addEventListener('pointermove', function (ev) {
        var r = t.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        t.style.setProperty('--mt-ry', (x * 7).toFixed(2) + 'deg');
        t.style.setProperty('--mt-rx', (-y * 7).toFixed(2) + 'deg');
      });
      t.addEventListener('pointerleave', function () {
        t.style.setProperty('--mt-ry', '0deg');
        t.style.setProperty('--mt-rx', '0deg');
      });
    });
  }

  /* ---------- Luces del hero que siguen al ratón ---------- */
  function iniciarHero(raiz) {
    if (reducido || !conRaton) return;
    var heroes = (raiz || document).querySelectorAll('[data-mt-hero]:not([data-mt-hero-listo])');
    heroes.forEach(function (hero) {
      hero.setAttribute('data-mt-hero-listo', '');
      var luces = hero.querySelector('.mt-hero__aurora');
      if (!luces) return;
      hero.addEventListener('pointermove', function (ev) {
        var r = hero.getBoundingClientRect();
        luces.style.setProperty('--mt-mx', ((ev.clientX - r.left) / r.width - 0.5).toFixed(3));
        luces.style.setProperty('--mt-my', ((ev.clientY - r.top) / r.height - 0.5).toFixed(3));
      });
    });
  }

  /* ---------- Botones "imán": se acercan un poco al cursor ---------- */
  function iniciarIman(raiz) {
    if (reducido || !conRaton) return;
    var botones = (raiz || document).querySelectorAll('.mt-hero__actions .mt-btn:not([data-mt-iman]), .mt-cta__achat .mt-btn:not([data-mt-iman])');
    botones.forEach(function (b) {
      b.setAttribute('data-mt-iman', '');
      b.addEventListener('pointermove', function (ev) {
        var r = b.getBoundingClientRect();
        var x = (ev.clientX - r.left - r.width / 2) * 0.16;
        var y = (ev.clientY - r.top - r.height / 2) * 0.22;
        b.style.transform = 'translate(' + x.toFixed(1) + 'px,' + (y - 3).toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  function iniciar(raiz) {
    iniciarTitulares(raiz);
    iniciarInclinacion(raiz);
    iniciarHero(raiz);
    iniciarIman(raiz);
  }

  function arrancar() {
    iniciarProgreso();
    iniciar(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // En el editor de Shopify las secciones se repintan: hay que volver a engancharlas.
  document.addEventListener('shopify:section:load', function (ev) { iniciar(ev.target); });
})();

/* ==========================================================================
   RACINEA V2 · SEGUNDA TANDA — ficha de producto
   Solo mira y adorna: los precios, el reloj y la oferta elegida los sigue
   gobernando mt-scripts.js. Aquí se escucha lo que él pinta y se anima.
   ========================================================================== */
(function () {
  'use strict';

  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function relanzar(el, clase) {
    if (!el || reducido) return;
    el.classList.remove(clase);
    void el.offsetWidth;                       // obliga a reiniciar la animación
    el.classList.add(clase);
  }

  /* ---------- Descuento sobre la foto: copia la píldora del precio ---------- */
  function iniciarDescuentoFoto() {
    var destino = document.querySelector('[data-mt-eco-foto]');
    var origen = document.querySelector('[data-mt-economie]');
    if (!destino || !origen || destino.dataset.mtListo) return;
    destino.dataset.mtListo = '1';
    var texto = destino.querySelector('[data-mt-eco-foto-txt]');

    function copiar(animar) {
      var t = (origen.textContent || '').replace(/\s+/g, ' ').trim();
      var visible = t !== '' && origen.style.display !== 'none';
      destino.hidden = !visible;
      if (visible && texto.textContent !== t) {
        texto.textContent = t;
        if (animar) relanzar(destino, 'mt-cambia');
      }
    }
    copiar(false);
    new MutationObserver(function () { copiar(true); })
      .observe(origen, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  }

  /* ---------- Precio: pequeño salto cada vez que cambia ---------- */
  function iniciarPrecio() {
    ['[data-mt-prix]', '[data-mt-economie]'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el || el.dataset.mtV2) return;
      el.dataset.mtV2 = '1';
      new MutationObserver(function () { relanzar(el, 'mt-cambia'); })
        .observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- Ofertas: latido al elegir ----------
     Se escucha el cambio del propio radio, NO las clases de la tarjeta:
     vigilar las clases y tocarlas desde el mismo vigilante se llamaba a sí
     mismo sin fin y dejaba la página bloqueada al cambiar de formato. */
  function iniciarOfertas() {
    if (document.documentElement.dataset.mtOfertasV2) return;
    document.documentElement.dataset.mtOfertasV2 = '1';
    document.addEventListener('change', function (ev) {
      var radio = ev.target;
      if (!radio || !radio.matches || !radio.matches('input[data-mt-offre]')) return;
      var elegida = radio.closest('.mt-offre');
      document.querySelectorAll('.mt-offre.mt-elegida').forEach(function (otra) {
        if (otra !== elegida) otra.classList.remove('mt-elegida');
      });
      if (elegida && radio.checked) relanzar(elegida, 'mt-elegida');
    });
  }

  /* ---------- Recuadro de la foto: solo con la primera foto ---------- */
  function iniciarCajaFoto() {
    var caja = document.querySelector('[data-mt-foto-caja]');
    var minis = document.querySelectorAll('[data-mt-miniatura]');
    if (!caja || !minis.length || caja.dataset.mtListo) return;
    caja.dataset.mtListo = '1';
    Array.prototype.forEach.call(minis, function (mini, i) {
      mini.addEventListener('click', function () {
        caja.classList.toggle('est-cachee', i !== 0);
      });
    });
  }

  /* ---------- Contador: tic de cada cifra y barra de tiempo ---------- */
  function iniciarContador() {
    document.querySelectorAll('[data-mt-reloj]:not([data-mt-v2])').forEach(function (caja) {
      caja.dataset.mtV2 = '1';
      var hh = caja.querySelector('[data-mt-reloj-h]');
      var mm = caja.querySelector('[data-mt-reloj-m]');
      var ss = caja.querySelector('[data-mt-reloj-s]');
      var barra = caja.querySelector('[data-mt-reloj-barre]');
      var horas = parseFloat(caja.dataset.horas) || 0;
      if (!hh || !mm || !ss) return;

      [hh, mm, ss].forEach(function (cifra) {
        new MutationObserver(function () { relanzar(cifra, 'mt-tic'); })
          .observe(cifra, { childList: true, characterData: true, subtree: true });
      });

      function barraAlDia() {
        var h = parseInt(hh.textContent, 10), m = parseInt(mm.textContent, 10), s = parseInt(ss.textContent, 10);
        if (isNaN(h) || isNaN(m) || isNaN(s) || !horas) return;
        var quedan = h * 3600 + m * 60 + s;
        var pct = Math.max(2, Math.min(100, (quedan / (horas * 3600)) * 100));
        if (barra) barra.style.setProperty('--mt-reste', pct.toFixed(2) + '%');
        caja.classList.toggle('est-urgente', quedan < 600);
      }
      new MutationObserver(barraAlDia).observe(ss, { childList: true, characterData: true, subtree: true });
      barraAlDia();
    });
  }

  function iniciar() {
    iniciarDescuentoFoto();
    iniciarPrecio();
    iniciarOfertas();
    iniciarCajaFoto();
    iniciarContador();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
})();

/* ==========================================================================
   RACINEA V2 — pack «Rutina completa»
   Botón propio: añade el producto del pack y lleva al carrito. Si el pack aún
   no tiene producto (vista previa), avisa y no toca el carrito.
   ========================================================================== */
(function () {
  'use strict';
  if (window.mtFullListo) return;
  window.mtFullListo = true;

  document.addEventListener('click', function (ev) {
    var boton = ev.target && ev.target.closest ? ev.target.closest('[data-mt-full-btn]') : null;
    if (!boton) return;
    ev.preventDefault();

    var caja = boton.closest('[data-mt-full]');
    var aviso = caja ? caja.querySelector('[data-mt-full-aviso]') : null;
    var id = Number(boton.getAttribute('data-variante'));

    if (!id) {                                   // vista previa: sin producto todavía
      if (aviso) aviso.hidden = false;
      return;
    }

    var hayTema = typeof Theme !== 'undefined' && Theme.routes;
    var rutaAnadir = (hayTema && Theme.routes.cart_add_url) || '/cart/add.js';
    var rutaCarrito = (hayTema && Theme.routes.cart_url) || '/cart';

    boton.setAttribute('aria-busy', 'true');
    fetch(rutaAnadir, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { window.location.href = rutaCarrito; })
      .catch(function () { boton.removeAttribute('aria-busy'); });
  });
})();
